// Checklist - PERLAI (about)

page.checklist.istorija = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    interval: null,
    check: function(){
        this.reset();
        if(page.v.firstLoad) this.first();

        if($(".timeline-slider").length > 0){
            log.page("CHECK: Istorija detected", 2);
            this.enabled = true;
        }
    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){
        this.interval = window.setTimeout(()=>{this.initRun()}, 1000);
    },
    initRun: function(){

        var apie_istorija = $(".timeline-slider");
        if(apie_istorija != undefined){
            var v = page.checklist.istorija.v;
            var f = page.checklist.istorija.f;
            v.idata = {};
            v.firstTime = true;
            v.idx = [];
            $(".timeline-mobile .ist-item-mobile").each(function(id,elem){
                let el = $(elem);
                let year = el.find(".ist-title").text();
                v.idata[year] = [];
                v.idx.push(year);

                el.find(".ist-desc-text").each(function(id2, elem2){
                    v.idata[year].push($(elem2).html().trim());
                })
            });

            v.svg = $(".timeline-slider svg");
            $(".timeline-mobile .ist-item-mobile .ist-title").each(function(id, k){
                //console.log(k, id);
                //console.log(idata[k][0]);
                v.svg.append(f.makeSVGpoint($(k).text(), 200 + id*100, 150));
            });
            v.svg.html(v.svg.html());

            v.svgLine = v.svg.find(".ist-linija");
            v.line = {
                length: v.svgLine.get(0).getTotalLength(),
                point: function(x){
                    return v.svgLine.get(0).getPointAtLength(Math.max(0, Math.min(x, v.line.length)));
                }
            }
            
            //console.log(svgLine);
            v.svgItems = v.svg.find(".ist-item");
            

            $(".timeline-mobile .ist-desc").css("display", "none");
            $(".timeline-mobile .ist-title").click(function (e) {
                e.preventDefault();
                f.activateSlide($(e.target).text());
            });
            v.svgItems.click(function(e){
                e.preventDefault();
                f.activateSlide($(this).find("text").text());
            })
        }


        this.resize();
    },
    first: function(){

    },
    unload: function(){
        window.clearTimeout(this.interval);

        
    },
    fadein: function(){

    },
    fadeout: function(){

    },
    calc: function(){

    },
    resize: function(){
        var v = page.checklist.istorija.v;
        var f = page.checklist.istorija.f;
        if(v.svgItems.length < 1) return;
        var gap; // 102 rapsai, 1005 isnyksta
        var iw = window.innerWidth;
        if(iw <= 1400){
            let diff = Math.max(-140, iw - 1400);
            this.f.moveSVGline(diff);
            let startpos = 200 + diff;
            let endpos = iw>1005?103:0;
            gap = (iw - (startpos + endpos)) / v.svgItems.length;
            //console.log(diff);
        }else{
            this.f.moveSVGline(0);
            gap = (iw - 303) / v.svgItems.length;
        }
        v.svgItems.each(function(id, elem){
            let p = v.line.point(id * gap);
            $(elem).attr("transform", "translate(".concat(p.x, ",", p.y, ")"));
        });
    },
    scroll: function(){

    },
    v: {
        idata :     {},
        firstTime : true,
        idx :       [],
        svg :       null,
        svgLine:    null,
        line:       null,
        svgItems:   null,
        activateTimeout: -1,

    },
    f: {
        activateSlide: function(n){
            /*$([docume nt.documentElement, document.body]).animate({
                scrollTop: $("#elementtoScrollToID").offset().top
            }, 2000); */
            var v = page.checklist.istorija.v;
            var f = page.checklist.istorija.f;
            if(v.idata[n] == undefined || v.idata[n] == null) return;
            let oid = v.idx.indexOf(n);
            if(v.firstTime){
                v.firstTime = false;
                TweenMax.to(window, 1, {scrollTo: $(".section-about-3 .section-inner h2").first().offset().top});
            }
            let cid = 0;
            let did = -1;
            v.svgItems.each(function(id, elem){
                let el = $(elem);
                if(el.hasClass("active")) did = id;
                if(el.find("text").text() == n){
                    el.addClass("active");
                    cid = id;
                }else{
                    el.removeClass("active");
                }
            });
            if(did == oid){
                f.deactivateSlide(n);
                return false;
            };
            cid = Math.floor((cid / v.svgItems.length)*3);
            let mlc = ["", "ist-center", "ist-right"];
            window.clearTimeout(v.activateTimeout);
            $(".timeline-container .timeline-slider .ist-desc-wrapper").addClass("active").removeClass("show-text").removeClass("ist-center").removeClass("ist-right").addClass(mlc[cid]);
    
            v.activateTimeout = window.setTimeout(function(e){
                $(".timeline-container .timeline-slider .ist-desc-item-box").html(f.makeDescDivs(n));
                //console.log("lol", makeDescDivs(n));
                $(".timeline-container .timeline-slider .ist-desc-wrapper").addClass("show-text");
            }, 300);
    
            $(".timeline-mobile .ist-desc").each(function (index, element) {
                // element == this
                let el = $(element);
                let title = el.parent().find(".ist-title");
    
                if (title.text() == n) {
                    if (el.css("display") == "none") {
                        el.slideDown("fast");
                        el.addClass("active");
                        title.addClass("active");
                    }
                } else {
                    if (el.css("display") != "none") {
                        el.slideUp("fast");
                        el.removeClass("active");
                        title.removeClass("active");
                    }
                }
            });
        },
    
        deactivateSlide: function(n){
            var v = page.checklist.istorija.v;
            if(v.idata[n] == undefined || v.idata[n] == null) return;
            v.svgItems.removeClass("active");
            $(".timeline-container .timeline-slider .ist-desc-wrapper").removeClass("active").removeClass("show-text").addClass("ist-center").removeClass("ist-right");
            $(".timeline-mobile .ist-desc").each(function (index, element) {
                // element == this
                let el = $(element);
                
                if (el.css("display") != "none") {
                    el.slideUp("fast");
                    el.removeClass("active");
                    el.parent().find(".ist-title").removeClass("active");
                }
            });
        },
    
        makeDescDivs: function(n){
            var v = page.checklist.istorija.v;
            if(v.idata[n] == undefined || v.idata[n] == null) return "";
            var out = '';
            v.idata[n].forEach(function(e){
                out += '<div class="ist-desc-item">'.concat(e,'</div>');
            });
            if(v.idata[n].length < 2) {
                out += '<div class="ist-desc-item no-dot"></div>';
            }
            return out;
        },
    
        makeSVGpoint: function(txt, x, y){
            return '<g transform="translate('.concat(Math.round(x),',', Math.round(y),')" class="ist-item"><rect width="100" height="200" transform="translate(-50,-100)" style="fill:rgba(0,255,255,0);stroke:none" /><line x1="0.5" y1="10" x2="0.5" y2="200" class="ist-item-line"/><text x="0" y="-30" class="ist-title">',txt,'</text><circle r="6.5" class="ist-circle-1" /><circle fill="none" r="9.5" class="ist-circle-2" /></g>');
        },
        
        moveSVGline: function(x){
            page.checklist.istorija.v.svgLine.attr("d", "M".concat(200+x,",150q430,32,860,0t860,-40t860,40t860,0t860,0t860,0t860,0t860,0"));
        }
    }
}